<template>
  <div class="horizontalScreen-platform" v-if="show">
    <slot></slot>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapState(['isMobile']),
      ...mapGetters(['displayHorizontal']),
      show() {
        return this.displayHorizontal
      },
    },
  }
</script>
